import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="card z-depth-2">
        <div
          className="card-image"
          style={{ maxHeight: "200px", overflow: "hidden" }}
        >
          <img
            src="/images/opt-lasers-KshEaH06rV8-unsplash.jpg"
            alt="About Us"
            style={{
              objectFit: "cover",
              objectPosition: "center",
              width: "100%",
            }}
          />
          <span className="card-title">
            <h1 className="white-text text-shadow">About Us</h1>
            <h5 className="white-text text-shadow">
              The story behind our 3D printing services
            </h5>
          </span>
        </div>
        <div className="card-content">
          <p className="flow-text">
            Welcome to our professional 3D printing service, founded and
            operated by Christopher McHaffie. We're passionate about bringing
            your ideas to life through the power of 3D printing technology.
          </p>
        </div>
      </div>

      {/* About Section */}
      <div className="section">
        <div className="row">
          <div className="col s12 m4">
            <div className="card-panel z-depth-1">
              <div className="center-align">
                <img
                  src="/images/chris-profile.png"
                  alt="Christopher McHaffie"
                  className="circle responsive-img"
                  style={{ width: '150px', height: '150px', objectFit: 'cover', margin: '10px 0' }}
                />
                <h4>Me</h4>
              </div>
              <p>
                Christopher McHaffie is an 18-year-old entrepreneur who turned
                his passion for 3D printing into a thriving business venture.
                What started as a hobby has evolved into a professional service
                dedicated to quality and innovation.
              </p>
            </div>
          </div>
          <div className="col s12 m4">
            <div className="card-panel z-depth-1">
              <div className="center-align">
              < img src="/images/chris-mission.jpeg"
                  alt="Christopher McHaffie"
                  className="circle responsive-img"
                  style={{ width: '150px', height: '150px', objectFit: 'cover', margin: '10px 0' }}
                />
                <h4>My Mission</h4>
              </div>
              <p>
                We strive to provide accessible, high-quality 3D printing
                services to individuals and businesses alike. Our goal is to
                help you transform your concepts into tangible reality with
                precision and attention to detail.
              </p>
            </div>
          </div>
          <div className="col s12 m4">
            <div className="card-panel z-depth-1">
              <div className="center-align">
              <img
                  src="/images/chris-approach.png"
                  alt="Christopher McHaffie"
                  className="circle responsive-img"
                  style={{ width: '150px', height: '150px', objectFit: 'cover', margin: '10px 0' }}
                />
                <h4>My Approach</h4>
              </div>
              <p>
                We combine technical expertise with creative problem-solving to
                deliver exceptional results. Every project is handled with care,
                from initial consultation to final production, ensuring your
                vision is realized exactly as you imagined.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Story Section */}
      <div className="section">
        <div className="card">
          <div className="card-content">
            <span className="card-title">My Story</span>
            <p>
              Christopher's journey into 3D printing began at age 15 when he
              received his first 3D printer as a gift. Fascinated by the
              technology's potential, he quickly mastered the technical aspects
              and began creating increasingly complex designs.
            </p>

            <p>
              As his skills developed, friends and family started requesting
              custom prints. Recognizing the opportunity to turn his passion
              into a business, Christopher established this service as an
              entrepreneurial venture at just 18 years old.
            </p>

            <p>
              Today, we serve a diverse clientele ranging from hobbyists and
              artists to small businesses and product developers. Christopher
              continues to expand his knowledge and capabilities, constantly
              exploring new materials, techniques, and applications to better
              serve our customers.
            </p>

            <blockquote>
              "I believe 3D printing is revolutionizing how we create and
              manufacture. My goal is to make this technology accessible to
              everyone with ideas worth bringing to life." - Christopher
              McHaffie
            </blockquote>
          </div>
        </div>
      </div>

      {/* Equipment Section */}
      <div className="section">
        <h2 className="center-align">My Equipment</h2>
        <div className="row">
          <div className="col s12 m6">
            <div className="card-panel z-depth-1">
              <div className="row valign-wrapper">
                <div className="col s3">
                  <i className="material-icons medium">
                    precision_manufacturing
                  </i>
                </div>
                <div className="col s9">
                  <h5>Professional Printers</h5>
                  <p>
                    We use industry-leading 3D printers that deliver exceptional
                    quality and precision for all your projects.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col s12 m6">
            <div className="card-panel z-depth-1">
              <div className="row valign-wrapper">
                <div className="col s3">
                  <i className="material-icons medium">category</i>
                </div>
                <div className="col s9">
                  <h5>Quality Materials</h5>
                  <p>
                    From standard PETG and PLA to PLA Plus and Hyper PLA,
                    we offer a wide range of colors to suit your specific needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="section">
        <div className="card-panel neon-card center-align z-depth-2">
          <h3>Ready to start your project?</h3>
          <p className="flow-text">
            Contact us today for a free consultation and quote.
          </p>
          <Link
            to="/contact"
            className="btn-large waves-effect waves-light white"
            style={{ color: "var(--primary-color)" }}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </>
  );
};

export default About;
